
















import { Component, Vue } from "vue-property-decorator";
import TitleHeader from "@/components/header.vue";
import { forgetPassword } from "@/req/forget";
@Component({
  components: {
    TitleHeader,
  },
})
export default class Home extends Vue {
  public username = "";
  public async submit() {
    const res = await forgetPassword({
      username: this.username,
    });
    if (res.code === 200) {
      this.$router.push({
        path: "/loginVerifyPhone",
        query: { phone: res.data.mobile },
      });
    } else {
      return this.$toast(res.msg);
    }
  }
}
